export { default } from './CarsTechSpec';
